// import mn from "./textMN.json";
// import en from "./textEN.json";
// import d from "./data.json";

import { GetAll, GetDate } from "./server";

export async function GetTravelData() {
    const d = await (await fetch("./data.json")).json();
    let travel = d.travels;
    travel.forEach((i) => {
        i.name =
            localStorage.getItem("language") === "mn" ? i.nameMN : i.nameEN;
        i.nameMain =
            localStorage.getItem("language") === "mn"
                ? i.nameMainMN
                : i.nameMainEN;
        i.description =
            localStorage.getItem("language") === "mn"
                ? i.descriptionMN
                : i.descriptionMN;
        i.type =
            localStorage.getItem("language") === "mn" ? i.typeMN : i.typeEN;
        i.detail =
            localStorage.getItem("language") === "mn" ? i.detailMN : i.detailEN;
    });
    return travel;
}
export async function GetTravelDataAll() {
    const d = await (await fetch("./data.json")).json();
    let travel = d.travels;
    travel.forEach((i) => {
        i.name =
            localStorage.getItem("language") === "mn" ? i.nameMN : i.nameEN;
        i.nameMain =
            localStorage.getItem("language") === "mn"
                ? i.nameMainMN
                : i.nameMainEN;
        i.description =
            localStorage.getItem("language") === "mn"
                ? i.descriptionMN
                : i.descriptionMN;
        i.type =
            localStorage.getItem("language") === "mn" ? i.typeMN : i.typeEN;
        i.detail =
            localStorage.getItem("language") === "mn" ? i.detailMN : i.detailEN;
    });

    const list = [];
    for (let i = 0; i < travel.length; i++) {
        const data = await GetDate(i);
        if (data.length > 0) {
            for (let j of data) {
                let copy = JSON.parse(JSON.stringify(travel[i]));
                copy.detail.startDate = j.data.startDate;
                copy.detail.startShort = j.data.startDate;
                copy.detail.endDate = j.data.endDate;
                list.push(copy);
            }
        }
    }

    return list;
}

export async function Data() {
    const mn = await (await fetch("./textMN.json")).json();
    const en = await (await fetch("./textEN.json")).json();
    return localStorage.getItem("language") === "mn" ? mn : en;
}

export async function GetDataPages() {
    const mn = await (await fetch("./otherDataMn.json")).json();
    const en = await (await fetch("./otherDataEn.json")).text();
    return localStorage.getItem("language") === "mn" ? mn : en;
}
